import { Typography } from '@mui/material';

type TitleProps = {
    children: string;
};

export function Title({ children }: TitleProps) {
    return (
        <Typography pb={1} minHeight="2.6rem" variant="h2">
            {children}
        </Typography>
    );
}
